export const checkIsPriceCalendar = (masterBook) => {
  // masterBookのprice_calendarsの中身があるかどうかを判定する。
  // price_calendarsがない場合は空配列
  return masterBook.price_calendars.length > 0;
};
